module.exports = __webpack_public_path__ + "img/plate-city-bg.d328e2a9.svg";